import React, { useEffect, useRef, useState } from "react";
import "./Email.css";
import { useGetContactsQuery } from "../../Api/api";
import emailjs from "@emailjs/browser";

const Email = (e) => {
  // const form = useRef();
  // const sendEmail = (e) => {
  //   e.preventDefault();

  //   emailjs
  //     .sendForm(
  //       process.env.REACT_APP_SERVICE_ID,
  //       process.env.REACT_APP_TEMPLATE_ID,
  //       form.current,
  //       process.env.REACT_APP_USER_ID
  //     )
  //     .then(
  //       (result) => {
  //         console.log(result.text);
  //       },
  //       (error) => {
  //         console.log(error.text);
  //       }
  //     );
  //   e.target.reset();
  // };
  // const { data: contacts, isFetching } = useGetContactsQuery();

  // const [contactsDetails, setContactDetails] = useState(contacts);
  // const img_300 = "http://127.0.0.1:8000";
  // useEffect(() => {
  //   setContactDetails(contacts);
  // }, [contactsDetails, contacts]);
  // if (isFetching) return "loading";
  return (
    <>
      <div className="reachme-container">
        <div className="reachme-title2">
          <h2>I Want To Hear From You</h2>

          <h3>Contact Me</h3>
        </div>
        <div className="row">
          <div className="col-md-5">
            <div className="reachme-title">
              <div className="row">
                
                    <div className="contact-info  ">
                      <div className="contact-details">
                        <i className='bx bx-phone'></i>
                        <div className="contact-mi">
                          <h4 className="icon-name"> Call Me:</h4>
                          <p className="d-name">+923436790664</p>
                        </div>
                      </div>
                    </div>
                    {/* email */}
                    <div className="contact-info  ">
                      <div className="contact-details">
                        <i className='bx bx-envelope'></i>
                        <div className="contact-mi">
                          <h4 className="icon-name"> Email Me:</h4>
                          <p className="d-name">dayakarma48@gmail.com</p>
                        </div>
                      </div>
                    </div>
                    {/* location */}
                    <div className="contact-info  ">
                      <div className="contact-details">
                        <i className='fa fa-map-marker'></i>
                        <div className="contact-mi">
                          <h4 className="icon-name"> location:</h4>
                          <p className="d-name">Hyderabad Latifabad unit 01</p>
                        </div>
                      </div>
                    </div>
                   
              </div>
            </div>
          </div>
          <div className="col-md-6 email-me container">
            <form >
              <div className="row">
                <div className="col-md-12 mb-3 hire-me-title"></div>
                <div className="col-md-6 ">
                  <input
                    type="text"
                    name="user_name"
                    id=""
                    placeholder="Enter Your Name"
                  />
                </div>
                <div className="col-md-6 ">
                  <input
                    type="email"
                    name="user_email"
                    id=""
                    placeholder="Enter Your Email"
                  />
                </div>
                <div className="col-md-12">
                  <input
                    type="text"
                    name="subject"
                    id=""
                    placeholder="Enter Subject"
                  />
                </div>
                <div className="col-md-12 mb-2">
                  <textarea
                    name="message"
                    id=""
                    cols="60"
                    rows="8"
                    placeholder="Your Message"
                  ></textarea>
                  <button className="hire-btn" type="submit">
                    Send Message
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Email;
